<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="navbar-op-duty-wrap">
      <op-duty-bar />
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img
          v-if="showAvatarImage"
          class="user-avatar"
          :src="avatar"
          @error="handleAvatarError"
        >
        <div v-else class="user-avatar avatar-fallback">
          <svg-icon icon-class="user"></svg-icon>
        </div>
        <span class="user-name" :title="displayName">{{ displayName }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item>
          <span @click="refreshMenus" style="display:block;">刷新菜单</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import OpDutyBar from './OpDutyBar'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    OpDutyBar
  },
  data() {
    return {
      avatarLoadFailed: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'nickName'
    ]),
    showAvatarImage() {
      return !!this.avatar && !this.avatarLoadFailed
    },
    /** 昵称优先，否则登录用户名 */
    displayName() {
      const n = this.nickName != null && String(this.nickName).trim() !== '' ? String(this.nickName).trim() : ''
      const u = this.name != null && String(this.name).trim() !== '' ? String(this.name).trim() : ''
      return n || u || '用户'
    }
  },
  watch: {
    avatar() {
      this.avatarLoadFailed = false
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    handleAvatarError() {
      this.avatarLoadFailed = true
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    refreshMenus() {
      this.$store.dispatch('RefreshMenus')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/styles/variables.scss";

.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background: rgba(247, 244, 238, 0.92);
  border-bottom: 1px solid $navbarBorder;
  box-shadow: 0 10px 24px rgba(138, 90, 24, 0.06);
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
    color: $navbarAccent;
  }
  .navbar-op-duty-wrap {
    position: absolute;
    right: 200px;
    top: 0;
    z-index: 8;
    display: flex;
    align-items: center;
    height: 50px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 2px 0 6px;
      border-radius: 14px;
      transition: background-color .25s ease;
      &:hover {
        background: rgba(244, 183, 64, 0.14);
      }
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        box-shadow: 0 6px 18px rgba(31, 41, 55, 0.16);
        object-fit: cover;
      }
      .avatar-fallback {
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(180deg, #fffaf0 0%, #f0e4ce 100%);
        border: 1px solid #e5d3b2;
        color: $navbarAccent;

        .svg-icon {
          width: 22px;
          height: 22px;
        }
      }
      .user-name {
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 500;
        color: #374151;
        line-height: 1.2;
      }
      .el-icon-caret-bottom {
        font-size: 12px;
        color: $navbarAccent;
        position: static;
        transform: translateY(1px);
        flex-shrink: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue